/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CurrencyDirective } from './currency/currency.directive';
import { OnlyNumberDirective } from './only-number/only-number.directive';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        OnlyNumberDirective,
        CurrencyDirective
    
    ],
    exports: [
        OnlyNumberDirective,
        CurrencyDirective
    ],
    providers: [DecimalPipe]
})
export class SharedDirectivesModule { }
